var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Button } from "../Button";
// styles
import "./modal.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-modal-header",
};
const ModalHeader = (_a) => {
    var { className, children, closeIcon, onClose, title, subtitle, backgroundImage, isBackgroundDark, style } = _a, rest = __rest(_a, ["className", "children", "closeIcon", "onClose", "title", "subtitle", "backgroundImage", "isBackgroundDark", "style"]);
    const classList = classNames("tecma-modal-header", className, {
        closeIcon,
        "dark-background": backgroundImage && !children && isBackgroundDark,
    });
    const content = () => {
        if (children) {
            return children;
        }
        return (_jsxs("div", { className: "tecma-modal-header__content", children: [title && _jsx("span", { className: "tecma-modal-header__content__title", children: title }), subtitle && _jsx("span", { className: "tecma-modal-header__content__subtitle", children: subtitle })] }));
    };
    return (_jsxs("div", Object.assign({ style: Object.assign(Object.assign({}, style), { backgroundImage: backgroundImage && !children ? `url(${backgroundImage})` : "none" }), className: classList }, rest, { children: [content(), closeIcon && (_jsx(Button, { iconName: "x", className: "tecma-modal-header__close-icon", onClick: onClose, color: "transparent" }))] })));
};
ModalHeader.defaultProps = defaultProps;
export default React.memo(ModalHeader);
